import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Slide from '@mui/material/Slide'
import Fade from '@mui/material/Fade'
import Backdrop from '@mui/material/Backdrop'
import styled from '@emotion/styled'

const functionModalBackdropProps = { timeout: 500 }

const Wrapper = styled(Box)`
  ${({ theme, $autoHeight }) => `
    position: relative;
    background-color: ${theme.palette.background.paper};
    width: 100%;
    height: 100%;
    margin: 0 auto;

    @media screen and (min-width: 992px) {
      margin-top: 20px;
      width: 540px;
      height: ${$autoHeight ? 'auto' : '737px'};
      border-radius: 10px;
    }
  `}
`

export const ScrollableBox = styled(Box)`
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;
  border: none;
  outline: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

// fullscreen in mobile devices
export const FunctionModal = ({
  open,
  onClose,
  children,
  autoHeight,
  ModalWrapper,
  ...rest
}) => {
  const UsedWrapper = ModalWrapper || Wrapper
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={functionModalBackdropProps}
      {...rest}
    >
      <Slide direction="up" in={open}>
        <ScrollableBox onClick={() => onClose && onClose()}>
          <UsedWrapper
            onClick={(e) => e.stopPropagation()}
            $autoHeight={autoHeight}
          >
            {children}
          </UsedWrapper>
        </ScrollableBox>
      </Slide>
    </Modal>
  )
}

const Fullscreen = styled.div`
  ${({ theme, $autoHeight }) => `
    position: relative;
    background-color: ${theme.palette.background.paper};
    width: 100%;
    height: ${$autoHeight ? 'auto' : '100%'};
    min-height: ${$autoHeight ? '100vh' : 'auto'};
    margin: 0 auto;
  `}
`

// fullscreen in any devices
export const FullscreenModal = ({
  open,
  onClose,
  children,
  autoHeight,
  ...rest
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={functionModalBackdropProps}
      {...rest}
    >
      <Slide direction="up" in={open}>
        <ScrollableBox onClick={() => onClose && onClose()}>
          <Fullscreen
            onClick={(e) => e.stopPropagation()}
            $autoHeight={autoHeight}
          >
            {children}
          </Fullscreen>
        </ScrollableBox>
      </Slide>
    </Modal>
  )
}

const InfoWrapper = styled(Box)`
  ${({ theme }) => `
    position: relative;
    background-color: ${theme.palette.background.paper};
    width: calc(100% - 60px);
    max-width: 540px;
    height: initial;
    margin: 0 auto;
    border-radius: 10px;
  `}
`

const UserDataWrapper = styled(Box)`
  ${({ theme }) => `
    overflow: hidden;
    position: relative;
    background-color: ${theme.palette.background.paper};
    width: 354px;
    height: initial;
    margin: 0 auto;
    font-size: 16px;
    border-radius: 12px;
    border: 1px solid ${theme.palette.grey.secondary};
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);
  `}

  @media screen and (min-width: 992px) {
    width: 540px;
    height: initial;
  }
`

// regular modal even in mobile devices
export const InfoModal = ({ open, onClose, children, ...rest }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={functionModalBackdropProps}
      {...rest}
    >
      <Fade in={open}>
        <ScrollableBox onClick={() => onClose && onClose()}>
          <Box pt="150px" pb="40px">
            <InfoWrapper onClick={(e) => e.stopPropagation()}>
              {children}
            </InfoWrapper>
          </Box>
        </ScrollableBox>
      </Fade>
    </Modal>
  )
}

// user data modal
export const UserDataModal = ({ open, onClose, children, ...rest }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={functionModalBackdropProps}
      {...rest}
    >
      <Fade in={open}>
        <ScrollableBox onClick={() => onClose && onClose()}>
          <Box pt="150px" pb="40px">
            <UserDataWrapper onClick={(e) => e.stopPropagation()}>
              {children}
            </UserDataWrapper>
          </Box>
        </ScrollableBox>
      </Fade>
    </Modal>
  )
}
